import axios from "axios";
import { DiagnosticsResponse } from "../types/diagnostics";
import { DIAGNOSTIC_API_BASE_URL } from './apiConfig';

const api = axios.create({
  baseURL: DIAGNOSTIC_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const runDiagnostics = async (urlOrQr: string): Promise<DiagnosticsResponse> => {
  const res = await api.post<any>("/api/diagnostics/website", { urlOrQr });
  return res.data;
};

export const getMyDiagnostics = async (): Promise<DiagnosticsResponse[]> => {
  const res = await api.get<any[]>("/api/diagnostics/website/my");
  return res.data;
};

export const runMarketingDiagnostics = async (answers: Record<string, string>) => {
  const res = await api.post("/api/diagnostics/marketing", { answers });
  return res.data;
};

export const getMarketingQuestions = async () => {
  const res = await api.get("/api/diagnostics/marketing/questions");
  return res.data;
};

export const runBusinessAssessment = async (answers: Record<string, string>) => {
  const res = await api.post("/api/diagnostics/business-assessment", { answers });
  return res.data;
};

export const getBusinessQuestions = async () => {
  const res = await api.get("/api/diagnostics/business-assessment/questions");
  return res.data;
};
